import axios from 'axios';
import React from 'react'
import { Component } from 'react';
import { baseURL, SERVER_IP } from '../../../constants/applicationConstants.js';
import { emailRegex, fetchArticleDataFromAPI, nameRegex, mixPannelEvent } from '../../../shared/helper.js';
import { Loader } from '../../common/loader/loader.jsx';
import HomeJsx from './home.jsx'

export default class Home extends Component {

  constructor(props) {
    super(props);
    this.state = {
      blogData: null,
      isProcessing: false,

      page: 1,
      blogType: 'Featured',
      quoteData: {
        type: null,
        name: null,
        email: null,
        phone: null,
        postalCode: null
      },
      formError: {},

      productData: [],
      offerData: [],
      sponsorAddsData: null,
      featureOffer: null,
      featureProduct: null,
      expertDataFull: null,
      instituteData: null,
      selectedOffer: 0,
      selecteddProduct: 0
    }
    
    // Create ref for slider reset callback
    this.sliderResetCallback = null;
  }
 
  // Method to set slider reset callback from child component
  setSliderResetCallback = (callback) => {
    this.sliderResetCallback = callback;
  }

  // Method to reset slider
  resetSlider = () => {
    if (this.sliderResetCallback) {
      this.sliderResetCallback();
    }
  }

  componentDidMount = () => {
   const mixpanelData = {
      eventName: "page_view_home",
      data: {
        name: "home"
      }
    }
    setTimeout(async () => {

      const fetchedData = await fetchArticleDataFromAPI("", this.getType[this.state.blogType], this.state.page,"",'');
      this.setState({ blogData: fetchedData.data.data, isProcessing: false });

    }, 500);

    this.getProductData();
    this.getSponsorAddsData();
    this.getFeatureCategoryOfferData();
    this.getFeatureCategoryProductData();

    sessionStorage.removeItem("selectCategory")
    this.getIPData();
    this.getOfferData();
    this.getExpertDataFull();
    this.getInstituteData();
    mixPannelEvent(mixpanelData);
  }

  getInstituteData = () => {
    // Check if data already exists in session storage
    this.setState({ isProcessing: true })
    const storedData = sessionStorage.getItem('instituteData');

    // If data exists in session storage, use it
    if (storedData) {
      this.setState({
        instituteData: JSON.parse(storedData),
        isProcessing: false,

      });
    } else {
      // If no data in session storage, call the API
      this.setState({ isProcessing: true });
      axios.get(`${baseURL}/featured-institutes`)
        .then(res => {
          const data = res.data.data;

          // Store the fetched data in session storage
          sessionStorage.setItem('instituteData', JSON.stringify(data));

          // Update the state with the fetched data
          this.setState({
            instituteData: data,
            isProcessing: false,

          });
        })
        .catch(error => {
          console.error('Error fetching sponsor data:', error);
          this.setState({ isProcessing: false });
        });
    }

  }

  getProductData = () => {
    // Check if data already exists in session storage
    this.setState({ isProcessing: true })
    const storedData = sessionStorage.getItem('productData');

    // Reset slider before updating data
    this.resetSlider();

    // If data exists in session storage, use it
    if (storedData) {
      this.setState({
        productData: JSON.parse(storedData),
        isProcessing: false,
        selecteddProduct: 0
      });
    } else {
      // If no data in session storage, call the API
      this.setState({ isProcessing: true });
      axios.get(`${baseURL}/homeFeaturedProducts`)
        .then(res => {
          const data = res.data.data;

          // Store the fetched data in session storage
          sessionStorage.setItem('productData', JSON.stringify(data));

          // Update the state with the fetched data
          this.setState({
            productData: data,
            isProcessing: false,
            selecteddProduct: 0
          });
        })
        .catch(error => {
          console.error('Error fetching sponsor data:', error);
          this.setState({ isProcessing: false });
        });
    }

  }

  getFeatureCategoryOfferData = () => {
    // Check if data already exists in session storage
    this.setState({ isProcessing: true })
    const storedData = sessionStorage.getItem('featureOffer');

    // If data exists in session storage, use it
    if (storedData) {
      this.setState({
        featureOffer: JSON.parse(storedData),
        isProcessing: false,

      });
    } else {
      // If no data in session storage, call the API
      this.setState({ isProcessing: true });
      axios.get(`${baseURL}/institutionCategory/getFeaturedSubcategories?isFeaturedOfferSubCategory=true&page=1&perPage=10`)
        .then(res => {
          const data = res.data.data;

          // Store the fetched data in session storage
          sessionStorage.setItem('featureOffer', JSON.stringify(data));

          // Update the state with the fetched data
          this.setState({
            featureOffer: data,
            isProcessing: false,

          });
        })
        .catch(error => {
          console.error('Error fetching sponsor data:', error);
          this.setState({ isProcessing: false });
        });
    }

  }
  
  getFeatureCategoryProductData = () => {
    // Check if data already exists in session storage
    this.setState({ isProcessing: true })
    const storedData = sessionStorage.getItem('featureProduct');

    // If data exists in session storage, use it
    if (storedData) {
      this.setState({
        featureProduct: JSON.parse(storedData),
        isProcessing: false,

      });
    } else {
      // If no data in session storage, call the API
      this.setState({ isProcessing: true });
      axios.get(`${baseURL}/institutionCategory/getFeaturedSubcategories?&isFeaturedProductSubCategory=true&page=1&perPage=10`)
        .then(res => {
          const data = res.data.data;

          // Store the fetched data in session storage
          sessionStorage.setItem('featureProduct', JSON.stringify(data));

          // Update the state with the fetched data
          this.setState({
            featureProduct: data,
            isProcessing: false,

          });
        })
        .catch(error => {
          console.error('Error fetching sponsor data:', error);
          this.setState({ isProcessing: false });
        });
    }

  }

  getSponsorAddsData = () => {
    // Check if data already exists in session storage
    this.setState({ isProcessing: true })
    const storedData = sessionStorage.getItem('sponsorAddsData');

    // If data exists in session storage, use it
    if (storedData) {
      this.setState({
        sponsorAddsData: JSON.parse(storedData),
        isProcessing: false
      });
    } else {
      // If no data in session storage, call the API
      this.setState({ isProcessing: true });
      axios.get(`${baseURL}/sponsorOffers?page=1&perPage=5`)
        .then(res => {
          const data = res.data.data;

          // Store the fetched data in session storage
          sessionStorage.setItem('sponsorAddsData', JSON.stringify(data));

          // Update the state with the fetched data
          this.setState({
            sponsorAddsData: data,
            isProcessing: false
          });
        })
        .catch(error => {
          console.error('Error fetching sponsor data:', error);
          this.setState({ isProcessing: false });
        });
    }
  };

  getOfferData = () => {
    // Check if data already exists in session storage
    this.setState({ isProcessing: true })
    const storedData = sessionStorage.getItem('offerData');

    // Reset slider before updating offer data
    this.resetSlider();

    // If data exists in session storage, use it
    if (storedData) {
      this.setState({
        offerData: JSON.parse(storedData),
        isProcessing: false,
        selectedOffer: 0
      });
    } else {
      // If no data in session storage, call the API
      this.setState({ isProcessing: true });
      axios.get(`${baseURL}/homeFeaturedOffers`)
        .then(res => {
          const data = res.data.data;

          // Store the fetched data in session storage
          sessionStorage.setItem('offerData', JSON.stringify(data));

          // Update the state with the fetched data
          this.setState({
            offerData: data,
            isProcessing: false,
            selectedOffer: 0
          });
        })
        .catch(error => {
          console.error('Error fetching sponsor data:', error);
          this.setState({ isProcessing: false });
        });
    }

  }

  getOfferById = (offer) => {
    this.setState({ isProcessing: true })

    // Reset slider before fetching new offer data
    this.resetSlider();

    axios.get(`${baseURL}/search-offers?institutionCategoryId=${offer?.parent?.parentId}&institutionSubCategoryId=${offer?.institutionCategoryId}`).then(res => {
      this.setState({ offerData: res.data.data, isProcessing: false, selectedOffer: offer?.institutionCategoryId })
    })
  }

  getProductById = (offer) => {
    this.setState({ isProcessing: true })
    
    // Reset slider before fetching new product data
    this.resetSlider();
    
    axios.get(`${baseURL}/search-products?institutionCategoryId=${offer?.parent?.parentId}&institutionSubCategoryId=${offer?.institutionCategoryId}`).then(res => {
      this.setState({ productData: res.data.data, isProcessing: false, selecteddProduct: offer?.institutionCategoryId })
    })
  }

  getExpertDataFull = (offer) => {
    // Check if data already exists in session storage
    this.setState({ isProcessing: true })
    const storedData = sessionStorage.getItem('expertDataFull');

    // If data exists in session storage, use it
    if (storedData) {
      this.setState({
        expertDataFull: JSON.parse(storedData),
        isProcessing: false,

      });
    } else {
      // If no data in session storage, call the API
      this.setState({ isProcessing: true });
      axios.get(`${baseURL}/featuredExpertsByCategories`)
        .then(res => {
          const data = res.data.data;

          // Store the fetched data in session storage
          sessionStorage.setItem('expertDataFull', JSON.stringify(data));

          // Update the state with the fetched data
          this.setState({
            expertDataFull: data,
            isProcessing: false,

          });
        })
        .catch(error => {
          console.error('Error fetching sponsor data:', error);
          this.setState({ isProcessing: false });
        });
    }

  }

  // get system ip
  getIPData = () => {
    axios.get(`https://api64.ipify.org?format=json`).then(response => {
      // const serverArray = SERVER_IP.split(",")
      // serverArray.map(value => {
      // })

      const arrIP = SERVER_IP.split(","); //convert string to array to check

      if (arrIP.includes(response?.data?.ip)) //Current IP of user
      {
        // write your logic
      }
      else {
        // write your logic
      }

    })
  }

  getType = {
    Featured: 'main_news',
    Trending: "trending",
    Latest: "featured",
    Glossary: "glossory"
  }

  onInputChangeHandler = (e) => {
    let name = e.target.name;
    let value = e.target.value;

    if (value) {
      if (!this.inputRegexValidation(name, value)) {
        this.setState(
          {
            quoteData: {
              ...this.state.quoteData,
              [name]: value,
            },
            formError: {
              ...this.state.formError,
              [name]: "regx",
            },
          },
          () => this.isFromSubmissionBlock()
        );
      } else {
        this.setState(
          {
            quoteData: {
              ...this.state.quoteData,
              [name]: value,
            },
            formError: {
              ...this.state.formError,
              [name]: "",
            },
          },
          () => this.isFromSubmissionBlock()
        );
      }
    } else {
      this.setState(
        {
          quoteData: {
            ...this.state.quoteData,
            [name]: value,
          },
          formError: {
            ...this.state.formError,
            [name]: "",
          },
        },
        () => this.isFromSubmissionBlock()
      );
    }
  };

  isFromSubmissionBlock = () => {
    let { name, email, phone, phoneNumber, message } = this.state.quoteData;

    if (name && email && phone && phoneNumber && message) {
      if (
        this.inputRegexValidation('name', name) &&
        this.inputRegexValidation('email', email) &&
        this.inputRegexValidation('phone', phone) &&
        phoneNumber && message
      ) {
        this.setState({
          formSubmitButtonDisable: false
        });
      }
      else {
        this.setState({
          formSubmitButtonDisable: true
        });
      }
    } else {
      this.setState({
        formSubmitButtonDisable: true
      });
    }
  };

  onTouchHandler = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (value === "") {
      this.setState({
        formError: {
          ...this.state.formError,
          [name]: "req",
        },
      });
    } else {
      if (!this.inputRegexValidation(name, value)) {
        this.setState({
          formError: {
            ...this.state.formError,
            [name]: "regx",
          },
        });
      }
    }
  };

  inputRegexValidation = (name, value) => {
    if (name === 'name')
      return nameRegex.test(value);
    else if (name === "email")
      return emailRegex.test(value);
    else if (name === "phone")
      return !this.getProperPhoneNumber(value).includes('_');

    return true;
  };

  getProperPhoneNumber = (value) => {

    if (!isNaN(value)) {
      return value
    }

    const number = value.split(' ');
    return number[0].replace('(', '').replace(')', '') + number[1] + number[2]
  }

  onSelectBlogType = (title) => {
    this.setState({ blogType: title }, () => fetchArticleDataFromAPI("", this.getType[this.state.blogType], this.state.page)
    );
  }

  onButtonClick = () => {
  }

  render() {
    return (
      <div>
        <HomeJsx
          blogData={this.state.blogData}

          onSelectBlogType={this.onSelectBlogType}
          quoteData={this.state.quoteData}
          onTouchHandler={this.onTouchHandler}
          onInputChangeHandler={this.onInputChangeHandler}
          formError={this.state.formError}
          onButtonClick={this.onButtonClick}
          resetSlider={this.resetSlider}
          productData={this.state.productData}
          offerData={this.state.offerData}
          featureProduct={this.state.featureProduct}
          featureOffer={this.state.featureOffer}
          getOfferById={this.getOfferById}
          getProductById={this.getProductById}

          getOfferData={this.getOfferData}
          getProductData={this.getProductData}
          expertDataFull={this.state.expertDataFull}
          sponsorAddsData={this.state.sponsorAddsData}
          instituteData={this.state.instituteData}
          selectedOfferCat={this.state.selectedOffer}
          selecteddProductCat={this.state.selecteddProduct}
          
          // Pass the slider reset callback setter to child component
          setSliderResetCallback={this.setSliderResetCallback}
        />
        {this.state.isProcessing && <Loader />}
      </div>
    )
  }
}